import { render, staticRenderFns } from "./PromotionUpsellGrid.vue?vue&type=template&id=8940bd7c&"
import script from "./PromotionUpsellGrid.vue?vue&type=script&lang=ts&"
export * from "./PromotionUpsellGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports